import {gql} from '@apollo/client'

export const GET_INVENTORY_LIST = gql`
  query getInventoryList(
    $page: Int!
    $limit: Int!
    $field: String
    $value: String
    $isActive: Boolean
  ) {
    getInventoryList(
      listFilter: {page: $page, limit: $limit}
      queryFilter: {field: $field, value: $value}
      isActive: $isActive
    ) {
      data {
        id
        productId
        productName
        mrpPerUnit
        batchNumber
        mrp
        createdDate
        sgst
        cgst
        expriryDate
        remainingQuantity
        quantity
        __typename
      }
      total
      pageSize
      page
      totalPages
      __typename
    }
  }
`

export const GET_VENDOR_LIST = gql`
  query getVendorList($page: Int!, $limit: Int!, $field: String, $value: String) {
    getVendorList(
      listFilter: {page: $page, limit: $limit}
      queryFilter: {field: $field, value: $value}
    ) {
      data {
        id
        mobileNumber
        name
        firmName
        __typename
        email
        zip
      }
      total
      pageSize
      page
      totalPages
      __typename
    }
  }
`

export const GET_PATIENT_LIST = gql`
  query getBusinessPatientPaginationList($page: Int!, $limit: Int!) {
    getBusinessPatientPaginationList(listFilter: {page: $page, limit: $limit}) {
      data {
        id
        mobileNumber
        name
        registrationDate
        dob
        profilePhoto
        __typename
      }
      total
      pageSize
      page
      totalPages
      __typename
    }
  }
`

export const GET_DASHBOARD_COUNT_TOP = gql`
  query getDashboardCounts {
    getDashboardCounts {
      medicineInStock
      expirySoon
      orderRestock
      registeredUser
      registeredVendor
      totalMonthlyOrder
      registeredDoctor
      doctorSaleOrder
      stockAmount
    }
  }
`

export const GET_DASHBOARD_REPORT_COUNT = gql`
  query getDashboardReportCount($month: Int!, $year: Int!) {
    getDashboardReportCount(month: $month, year: $year) {
      quantityOFSoldMedicine
      invoiceGenerated
      revenue
      profit
    }
  }
`

export const GET_REPORT_COUNT = gql`
  query getMonthlyReportCount($month: Int!, $year: Int!) {
    getMonthlyReportCount(month: $month, year: $year) {
      totalSalesOrder
      totalVendors
      totalPurchaseOrder
      totalPatients
    }
  }
`

export const GET_SCAN_DASHBOARD_REPORT_COUNT = gql`
  query {
    getDiagnosisReportCount {
      registeredUser
      registeredDoctor
      todayActiveAppointment
      waitingForResult
      reportReady
      closedReport
      consumerAppointment
      doctorAppointment
    }
  }
`

export const GET_SCAN_REPORT_COUNT = gql`
  query getDiagnosisMonthlyCount($month: Int!, $year: Int!) {
    getDiagnosisMonthlyCount(month: $month, year: $year) {
      monthlyTransaction
      monthlyAppointment
      monthlyRevenue
    }
  }
`

export const GET_MATCHED_PRODUCT_LIST = gql`
  query getMatchedProductList(
    $productName: String!
    $isBusinessAdmin: Boolean
    $page: Int!
    $limit: Int!
    $searchBy: searchByFilter
  ) {
    getMatchedProductList(
      productName: $productName
      isBusinessAdmin: $isBusinessAdmin
      listFilter: {page: $page, limit: $limit}
      searchBy: $searchBy
    )
  }
`

export const GET_MATCHED_MEDICINE_AUTOCOMPLETE = gql`
  query getMatchedMedicineList($name: String!, $limit: Int!) {
    getMatchedMedicineList(name: $name, limit: $limit) {
      id
      name
      generic
      category
      price
      weight
      quantity
      manufacturer
    }
  }
`

export const GET_SCAN_APPOINTMENT_CANCLE_SETTING = gql`
  query {
    getScanAppointmentCancellationSettings {
      id
      appointmentCancellationBeforeTime
      appointmentCancellationBeforeUnit
    }
  }
`

export const GET_BUSINESS_PATIENT_LIST_PHARMA = gql`
  query {
    getPharmacyScanBusinessPatient {
      mobileNumber
      name
      gender
      userAddress {
        id
        street
        city
        district
        state
        country
      }
      outstandingBalance
    }
  }
`

export const GET_PATIENT_LIST_SEARCH = gql`
  query getPatientListSearch($searchString: String!) {
    getPatientListSearch(searchString: $searchString)
  }
`

export const GET_MATCHED_DOCTOR_LIST = gql`
  query getDoctorSearchList($searchString: String!) {
    getDoctorSearchList(searchString: $searchString)
  }
`

export const GET_PRESCRIPTION_MEDICINE_DETAILS = gql`
  query getPrescribeMedicineDetail($medicineInput: [medicines!]) {
    getPrescribeMedicineDetail(medicineInput: $medicineInput)
  }
`

export const GET_UNIVERSAL_DISCOUNT = gql`
  query getUnversalDiscount {
    getUnversalDiscount {
      id
      isActive
      discountInPrecentage
    }
  }
`

export const GET_PHARMACY_DEFAULT_TEMP = gql`
  query {
    getPharmaDefaultTemplate {
      templateType
    }
  }
`

export const GET_DOCTOR_SALE_ORDER = gql`
  query getSaleOrderByDoctorV1($listFilter: listFilterInput!, $queryFilter: searchQueryInput) {
    getSaleOrderByDoctorV1(listFilter: $listFilter, queryFilter: $queryFilter) {
      data {
        id
        doctorId
        patientId
        doctorContactNumber
        patientContactNumber
        doctorFirstName
        doctorLastName
        patientFirstName
        patientLastName
        rxPdfUrl
        medicineDetail {
          medicineId
          batchNumber
          medicineName
          medicineDescription
          doases
          duration
          durationType
          durationTime
          quantity
          medicineType
        }
        createdDate
      }
      total
      pageSize
      page
      totalPages
    }
  }
`
export const ADD_SALES_ORDER_DETAILS = gql`
  query getSaleOrderByDoctorDetail($medicineInput: [medicines!]) {
    getSaleOrderByDoctorDetail(medicineInput: $medicineInput) {
      productId
      productName
      mrpPerUnit
      ratePerUnit
      expriryDate
      manufacutureDate
      manufacturer
      batchNumber
      remainingQuantity
      packUnit
      discountGroupName
      discountInPrecentage
      isIndividualDiscountActive
      medicineStatus
      quantityNew
      cgst
      sgst
    }
  }
`

export const GET_TEMPLATE_FIELDS = gql`
  query getPharmacyTemplate {
    getPharmacyTemplate {
      name
      showDiscount
      showGst
      showAmount
      showManufacturer
      showExpriryDate
      showQuantity
      showBatchNumber
      showProductName
    }
  }
`

export const GET_OCR_KEY = gql`
  query {
    getOCRKey {
      AZURE_AI_SECRET_KEY
      AZURE_AI_FE_ENDPOINT
      APP_OCR_AI
      BUSINESS_OCR_AI
      ENFORCE_APP_LEVEL_OCR
    }
  }
`

export const GET_SALES_ORDER_LST = gql`
  query getSalesOrderList(
    $listFilter: listFilterInput!
    $startDate: Date
    $endDate: Date
    $startNetAmount: Float
    $endNetAmount: Float
    $invoiceNo: String
    $customerName: String
    $customerPhoneNumber: String
  ) {
    getSalesOrderList(
      listFilter: $listFilter
      startDate: $startDate
      endDate: $endDate
      startNetAmount: $startNetAmount
      endNetAmount: $endNetAmount
      invoiceNo: $invoiceNo
      customerName: $customerName
      customerPhoneNumber: $customerPhoneNumber
    ) {
      total
      page
      data {
        id
        customerName
        invoiceUrl
        customerPhoneNumber
        invoiceNo
        saleDate
        netAmount
        totalGstAmount
        totalDiscountAmount
        paymentMode
        totalSgst
        totalCgst
        isInvoiceReturn
        customerId
        totalAmount
        paymentStatus
        outstandingAmount
        templateDetails {
          footerContent
          showProductName
          showBatchNumber
          showQuantity
          showExpriryDate
          showManufacturer
          showAmount
          showGst
          showDiscount
        }
        returnHistory {
          id
          customerId
          saleOrderId
          invoiceNo
          returnDate
          returnNote
          totalUnits
          totalAmount
          totalGstAmount
          netAmount
          totalDiscountAmount
          paymentStatus
          customerName
          doctorName
          customerPhoneNumber
          doctorPhoneNumber
          doctorId
          footerContent
          refundAmount
          outstandingAmount
          templateDetails {
            footerContent
            showProductName
            showBatchNumber
            showQuantity
            showExpriryDate
            showManufacturer
            showAmount
            showGst
            showDiscount
          }
        }
      }
    }
  }
`

export const GET_SALE_ORDER_RETURN_LIST = gql`
  query getSaleOrderReturnListV1(
    $listFilter: listFilterInput!
    $startDate: Date
    $endDate: Date
    $startNetAmount: Float
    $endNetAmount: Float
    $invoiceNo: String
    $customerName: String
    $customerPhoneNumber: String
  ) {
    getSaleOrderReturnListV1(
      listFilter: $listFilter
      startDate: $startDate
      endDate: $endDate
      startNetAmount: $startNetAmount
      endNetAmount: $endNetAmount
      invoiceNo: $invoiceNo
      customerName: $customerName
      customerPhoneNumber: $customerPhoneNumber
    ) {
      total
      pageSize
      page
      totalPages
      data {
        id
        customerId
        saleOrderId
        invoiceNo
        returnDate
        returnNote
        totalUnits
        totalAmount
        totalGstAmount
        netAmount
        totalDiscountAmount
        paymentStatus
        customerName
        doctorName
        customerPhoneNumber
        doctorPhoneNumber
        doctorId
        footerContent
        refundAmount
        outstandingAmount
        templateDetails {
          footerContent
          showProductName
          showBatchNumber
          showQuantity
          showExpriryDate
          showManufacturer
          showAmount
          showGst
          showDiscount
        }
      }
    }
  }
`

export const GET_SALE_ORDER_RETURN_DETAIL = gql`
  query getSaleOrderReturnDetail($id: ID) {
    getSaleOrderReturnDetail(id: $id)
  }
`

export const GET_PURCHASE_ORDER_RETURN_LIST = gql`
  query getPurchaseOrderReturnListV1(
    $listFilter: listFilterInput!
    $invoiceNo: String
    $name: String
    $startDate: Date
    $endDate: Date
    $startNetAmount: Float
    $endNetAmount: Float
  ) {
    getPurchaseOrderReturnListV1(
      listFilter: $listFilter
      invoiceNo: $invoiceNo
      name: $name
      startDate: $startDate
      endDate: $endDate
      startNetAmount: $startNetAmount
      endNetAmount: $endNetAmount
    ) {
      data {
        id
        vendorId
        purchaseOrderId
        invoiceNo
        returnDate
        returnNote
        totalUnits
        totalAmount
        totalSgst
        totalCgst
        totalGstAmount
        netAmount
        totalDiscountAmount
        invoiceDate
        name
        paymentStatus
        isInvoiceReturn
        outstandingAmount
        cashDiscount
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const GET_PURCHASE_ORDER_RETURN_DETAIL = gql`
  query getPurchaseOrderReturnDetail($id: ID) {
    getPurchaseOrderReturnDetail(id: $id)
  }
`

// export const GET_PURCHASE_ORDER_LST = gql`
//   query getPurchaseOrderList($listFilter: listFilterInput!){
//     getPurchaseOrderList(listFilter: $listFilter) {
//       total
//       page
//       pageSize
//       totalPages
//       data {
//         id
//         purchaseOrderId
//         invoiceNo
//         invoiceDate
//         totalUnits
//         totalAmount
//         isReturn
//         returnDate
//         totalDiscountAmount
//         totalGstAmount
//         netAmount
//         isInvoiceReturn
//         paymentStatus
//         outstandingBalance
//         name
//         outstandingAmount
//         cashDiscount
//       }
//     }
//   }
// `;

export const GET_PURCHASE_ORDER_LST = gql`
  query getPurchaseOrderList(
    $listFilter: listFilterInput!
    $invoiceNo: String
    $name: String
    $startDate: Date
    $endDate: Date
    $startNetAmount: Float
    $endNetAmount: Float
  ) {
    getPurchaseOrderList(
      name: $name
      listFilter: $listFilter
      invoiceNo: $invoiceNo
      startDate: $startDate
      endDate: $endDate
      startNetAmount: $startNetAmount
      endNetAmount: $endNetAmount
    ) {
      total
      pageSize
      page

      totalPages
      data {
        id
        purchaseOrderId
        invoiceNo
        invoiceDate
        totalUnits
        totalAmount
        isReturn
        returnDate
        totalDiscountAmount
        totalGstAmount
        netAmount
        isInvoiceReturn
        paymentStatus
        outstandingBalance
        name
        outstandingAmount
        cashDiscount
        returnHistory {
          id
          purchaseOrderId
          vendorId
          invoiceNo
          returnDate
          returnNote
          totalAmount
          netAmount
          cashDiscount
          totalGstAmount
          totalUnits
        }
      }
    }
  }
`

export const GET_PURCHASE_ORDER_DETAILS = gql`
  query getPurchaseOrderDetail($purchaseOrderId: ID) {
    getPurchaseOrderDetail(purchaseOrderId: $purchaseOrderId) {
      vendorId
      outstandingAmount
      orderDetail {
        productId
        productName
        hsnCode
        batchNumber
        pack
        packUnit
        itemQuantity
        mrpPerUnit
        ratePerUnit
        mrp
        rate
        manufacutureDate
        manufacturer
        expriryDate
        cgst
        sgst
        value
        discountPerUnit
        discountAmount
        discount
        remainingQuantity
        generic
        returnQuantity
        maxReturnQuantity
      }
    }
  }
`

export const GET_SALE_ORDER_DETAILS = gql`
  query getSalesOrderDetail($id: ID!) {
    getSalesOrderDetail(id: $id) {
      outstandingAmount
      orderDetail {
        productId
        productName
        hsnCode
        batchNumber
        packUnit
        quantity
        mrp
        rate
        gst
        manufacutureDate
        manufacturer
        expriryDate
        cgst
        sgst
        discountAmount
        discount
        returnQuantity
        maxReturnQuantity
        advanceDegrees
        specialty
      }
    }
  }
`

export const GET_BUSINESS_STAFF_LIST = gql`
  query getBusinessStaffListV2(
    $role: String
    $page: Int!
    $limit: Int!
    $sortBy: String
    $sortOrder: Int
    $searchValue: String
  ) {
    getBusinessStaffListV2(
      role: $role
      searchValue: $searchValue
      listFilter: {page: $page, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder}
    ) {
      data {
        userId
        businessName
        businessId
        userRoleId
        firstName
        lastName
        role
        isStaffActive
        systemRole
        mobileNumber
        appointmentDurationTime
        appointmentDurationUnit
        appointmentCancellationBeforeTime
        appointmentCancellationBeforeUnit
        __typename
      }
      total
      totalPages
      page
      pageSize
      __typename
    }
  }
`

export const GET_BUSINESS_USER_PROFILE = gql`
  query getBusinessUserProfile($userRoleId: ID!) {
    getBusinessUserProfile(userRoleId: $userRoleId) {
      userProfile {
        id
        userId
        userRoleId
        firstName
        lastName
        gender
        email
        dob
        bloodGroup
        userTechDetails {
          mciNumber
          stateCouncil
          specialty
        }
      }
      userAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      countryCode
      mobileNumber
      role
      systemRole
      isRoleActive
      isUserRegistered
    }
  }
`

export const GET_DASHBOARD_COUNT_TOP_V1 = gql`
  query getDashboardCountsV1($startDate: DateTime!, $endDate: DateTime!) {
    getDashboardCountsV1(startDate: $startDate, endDate: $endDate) {
      medicineInStock
      expirySoon
      orderRestock
      registeredUser
      registeredVendor
      totalMonthlyOrder
      registeredDoctor
      doctorSaleOrder
      expiredMedicine
      doctorSaleOrderCreated
      doctorSaleOrderCompleted
      totalSaleOrder
      stockAmount
      totalSaleOrderCompleted
      totalSaleOrderReturned
      topSellingMedicines {
        id
        timesSold
      }
      saleOrderRevenue
    }
  }
`

export const GET_DISCOUNT_GROUP_LIST = gql`
  query getDiscountGroupList {
    getDiscountGroupList
  }
`

export const GET_BILLING_TEMPLATE_FIELDS = gql`
  query getTemplateByType($type: String!) {
    getTemplateByType(type: $type) {
      id
      title
      templateType
      showProductName
      showBatchNumber
      showQuantity
      showExpriryDate
      showManufacturer
      showAmount
      showGst
      showDiscount
      footerContent
    }
  }
`

export const GET_INVENTORY_PRODUCT_UPDATE_HISTORY = gql`
  query getInventoryProductUpdateHistory(
    $documentId: ID!
    $listFilter: listFilterInput
    $startDate: DateTime
    $endDate: DateTime
  ) {
    getInventoryProductUpdateHistory(
      documentId: $documentId
      listFilter: $listFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      data {
        field
        oldValue
        newValue
        updatedBy
        createdDate
      }
      total
      pageSize
      page
      totalPages
    }
  }
`
